import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  createIndeedFlexLongTermAssignment,
  type CreateIndeedFlexLongTermAssignmentParams,
} from 'api/admin/indeedFlex/createIndeedFlexLongTermAssignment'
import { indeedFlexKeys } from './keys'

export const useCreateIndeedFlexLongTermAssignmentMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: CreateIndeedFlexLongTermAssignmentParams) =>
      createIndeedFlexLongTermAssignment(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.shiftIssues(),
      })
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.jobShifts(),
      })
    },
  })
}
